import React from 'react';
import { PrivacyPolicyContainer } from '../PrivacyPolicy/PrivacyStyles.styles';

const Payment = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Payment Terms</h3>
      <p>
        Payments for courses and services are processed through third-party
        payment processors such as PayPal. By making a payment, you agree to the
        terms and conditions of the payment processor. Yoda Safety Services is
        not responsible for any errors or issues arising from the payment
        processor.
      </p>
      <h4>Refund Policy</h4>
      <p>
        All courses are non-refundable unless otherwise stated. Refunds may be
        issued at our sole discretion in cases of technical errors or duplicate
        payments. To request a refund, please contact us at{' '}
        <a href="mailto:yodasafetyservices1@outlook.com">
          yodasafetyservices1@outlook.com
        </a>
        .
      </p>
      <h4>Taxes</h4>
      <p>
        Users are responsible for any applicable taxes related to their
        purchases. Taxes may vary depending on your location and will be
        calculated at checkout.
      </p>
      <h4>Currency and Fees</h4>
      <p>
        All transactions are processed in CAD. Additional fees, such as foreign
        exchange fees, may apply depending on your payment method or location.
      </p>
      <h4>Failed or Disputed Payments</h4>
      <p>
        In the event of a failed payment, your access to the purchased services
        may be restricted until the payment is successfully processed. For
        disputed payments or chargebacks, we reserve the right to suspend your
        account until the issue is resolved.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default Payment;
